import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-toolbar-language",
  templateUrl: "toolbar-language.html",
})
export class ToolbarLanguageComponent {

  @Input() public title: string = null;
  @Input() public model: string;
  @Input() public defaultLanguage: string;
  @Output() public languageChange = new EventEmitter();

  public selected() {
    this.languageChange.emit(this.model);
  }
}



// WEBPACK FOOTER //
// ./src/components/toolbar-language/toolbar-language.ts